import React from 'react'
import {compose, setDisplayName} from "recompose";
import {connect} from "react-redux";
import {withRouter} from "react-router";

import "./Advantages.css"
import "../Dashboard/Dashboard.css"
import {setIsLogin, setLanguage, userData} from "../../actions/user";
import {loadLangInUrl, updateLangInUrl} from "../../utilities";
import {getCurrentPlan, getPlans} from "../../actions/plans";
import {getLocaleString} from "../../locale";

const mapStateToProps = (state) => ({
    user: state.user,
    userId: state.userData.data.user_id,
    language: state.userData.language || navigator.language || navigator.userLanguage,
    login: state.userData.data.login
})

const mapDispatchToProps = (dispatch) => ({
    userData: () => dispatch(userData()),
    setLanguage: (lang) => dispatch(setLanguage(lang)),
    getPlans: () => dispatch(getPlans()),
    getCurrentPlan: () => dispatch(getCurrentPlan()),
    setIsLogin: (status) => dispatch(setIsLogin(status)),
})

export const enhance = compose(
    setDisplayName('Advantages'),
    connect(mapStateToProps, mapDispatchToProps)
)


export class View extends React.Component {
    UNSAFE_componentWillMount() {
        this.props.setIsLogin(false)
    }

    componentDidMount() {
        const {props: {user, login, userData, language, setLanguage, getPlans, getCurrentPlan}} = this
        if (user && !login) {
            userData()
            getPlans()
            getCurrentPlan()
        }
        loadLangInUrl(this.props, language, setLanguage)
    }

    UNSAFE_componentWillUpdate(nextProps) {
        updateLangInUrl(this.props, nextProps)
    }

    render() {
        return (
          <div className="Static__wrapper" dangerouslySetInnerHTML={{ __html: getLocaleString('seo.advantages') }} />
        )
    }
}

export const Advantages = withRouter(enhance(View))

export default withRouter(enhance(View))